<mat-dialog-content>
  <div>
    <mat-form-field class="form-field" color="accent">
      <mat-label>Id</mat-label>
      <input [(ngModel)]="id" matInput>
    </mat-form-field>
    <mat-form-field class="form-field" color="accent">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="name" matInput>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="form-field" color="accent">
      <mat-label>Content Type</mat-label>
      <mat-select [(value)]="contenttype" (selectionChange)="onContentTypeChange($event.value)">
        <mat-option *ngFor="let type of mediaTypes" [value]="type">
          {{ type }}
        </mat-option>
        <mat-option value="other">Other</mat-option>
      </mat-select>
    </mat-form-field>
    
    <mat-form-field *ngIf="isOtherSelected" class="form-field" color="accent">
      <mat-label>Enter Custom Content Type</mat-label>
      <input matInput [(ngModel)]="contenttype" placeholder="Enter content type">
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="form-field" color="accent">
      <mat-label>Version</mat-label>
      <input [(ngModel)]="version" matInput [placeholder]="'1.0'">
    </mat-form-field>
    <mat-form-field class="form-field" color="accent" id="form-field-baseurl">
      <mat-label>Base url</mat-label>
      <input [(ngModel)]="baseUrl" matInput>
    </mat-form-field>
  </div>

  <!-- In case of the REST API asset type -->
  <div>
    <mat-checkbox [(ngModel)]="isProxyPath" color="accent">
      Allow proxy path
    </mat-checkbox>
  </div>

  <div>
    <mat-checkbox [(ngModel)]="isProxyQueryParams" color="accent">
      Allow proxy query params
    </mat-checkbox>
  </div>

  <!-- HttpData Options Section -->
  <div class="rest-api-options">
    <h4>HttpData Source Options</h4>
    
    <!-- Display options -->
    <div>
      <mat-checkbox [(ngModel)]="isDisplayBaseUrl" color="accent">
        Allow baseUrl display
      </mat-checkbox>
    </div>

    <!-- Headers -->
    <div>
      <h5>Authentication header (Optional)</h5>

      <!-- Authentication Tabs -->
      <mat-tab-group (selectedTabChange)="onAuthorizationTypeTabChange($event)">
        <mat-tab label="Authorization Token">
          <div class="tab-content">
            <mat-form-field class="form-field">
              <mat-label>Authorization Token (Authorization header)</mat-label>
              <input matInput [(ngModel)]="authToken" placeholder="Enter authorization token">
            </mat-form-field>
          </div>
        </mat-tab>
        <mat-tab label="API Key">
          <div class="tab-content">
            <mat-form-field class="form-field">
              <mat-label>API Key (x-api-key header)</mat-label>
              <input matInput [(ngModel)]="apiKey" placeholder="Enter API key">
            </mat-form-field>
          </div>
        </mat-tab>
        <mat-tab label="OAuth 2.0">
          <div class="tab-content">
            <mat-form-field class="form-field">
              <mat-label>client id</mat-label>
              <input matInput [(ngModel)]="iamClientId" placeholder="Enter Client Id">
            </mat-form-field>
            <mat-form-field class="form-field">
              <mat-label>client secret</mat-label>
              <input matInput [(ngModel)]="iamClientSecret" placeholder="Enter Client Secret">
            </mat-form-field>
            <mat-form-field class="form-field">
              <mat-label>endpoint</mat-label>
              <input matInput [(ngModel)]="iamTokenUrl" placeholder="Enter IAM Endpoint">
            </mat-form-field>
            <mat-form-field class="form-field">
              <mat-label>scope (optional)</mat-label>
              <input matInput [(ngModel)]="iamScope" placeholder="Enter token scope (optional)">
            </mat-form-field>
            <mat-form-field class="form-field">
              <mat-label>Grant Type</mat-label>
              <mat-select [(ngModel)]="iamGrantType" placeholder="Select grant type">
                <mat-option *ngFor="let grant of grantTypes" [value]="grant">
                  {{ grant }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="iamGrantType==='password'">
              <mat-form-field class="form-field">
                <mat-label>user</mat-label>
                <input matInput [(ngModel)]="iamUser" placeholder="Enter user">
              </mat-form-field>
              <mat-form-field class="form-field">
                <mat-label>password</mat-label>
                <input matInput [(ngModel)]="iamPassword" placeholder="Enter password">
              </mat-form-field>
            </ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>

      <h5>Static headers (Optional)</h5>

      <div *ngFor="let param of staticHeaders; let i = index" class="query-param-row">
        <mat-form-field class="form-field">
          <mat-label>Key</mat-label>
          <input matInput [(ngModel)]="param.key" placeholder="Enter key">
        </mat-form-field>
        <mat-form-field class="form-field">
          <mat-label>Value</mat-label>
          <input matInput [(ngModel)]="param.value" placeholder="Enter value">
        </mat-form-field>
        <button mat-icon-button color="warn" (click)="removeHeader(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <button mat-stroked-button color="primary" (click)="addHeader()">
        <mat-icon>add</mat-icon> Add Header
      </button>

      <!-- Metadata Entries Section as JSONld parser -->
      <h5>Additional metadata (Optional)</h5>
      <jsonld-code-display [content]="metadataEntries" [isCopyButton]="false" [isEditable]="true" (contentChange)="onJsonLdUpdated($event)"/>

    </div>
  </div>
</mat-dialog-content>


<mat-dialog-actions>
    <button (click)="onSave()" color="accent" mat-stroked-button>
        <mat-icon>add_circle_outline</mat-icon> Create
    </button>

    <button color="accent" mat-dialog-close mat-stroked-button>
        <mat-icon>cancel</mat-icon> Cancel
    </button>
</mat-dialog-actions>
